import { Component, EventEmitter, OnChanges, Output, Signal, ViewChild, computed, input, model } from '@angular/core';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { TableColumn } from '@r1-compass-library/components';
import { IamDivision, IamRole, IamUser } from '@r1-compass-library/models';

import { Pipe, PipeTransform } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Pipe({
    // eslint-disable-next-line @angular-eslint/pipe-prefix
    name: 'csv',
})
export class CSVPipe implements PipeTransform {
    transform(value: string[] | undefined): string {
        return value?.join(', ') ?? '';
    }
}

type IamUserTableData = {
    id: number;
    user: string;
    divisions: string[];
    role: string;
    actions: { value: string; display: string }[];
};

@Component({
    selector: 'r1-compass-app-user-table',
    imports: [
        MatTableModule,
        MatPaginatorModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatSortModule,
        MatInputModule,
        CSVPipe,
        FormsModule,
        MatFormFieldModule,
    ],
    templateUrl: './user-table.component.html',
    styleUrl: './user-table.component.scss',
})
export class UserTableComponent implements OnChanges {
    columns = input.required<TableColumn[]>();
    userTableData = input.required<IamUser[]>();
    divisions = input.required<IamDivision[]>();
    roles = input.required<IamRole[]>();
    userSearchState = model<string>('');

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatTable) table!: MatTable<IamUser>;
    @ViewChild(MatSort) sort!: MatSort;

    displayedColumns: Signal<string[]> = computed(() => this.columns().map(column => column.columnDef));
    dataSource = new MatTableDataSource<IamUserTableData>([]);

    @Output()
    clickOption = new EventEmitter<{ optionValue: string; id: number }>();

    @Output()
    addUser = new EventEmitter<void>();

    private iamUserTableData = computed<IamUserTableData[]>(() => {
        return this.userTableData()?.map(dataEntry => {
            const usersDivisionsIds = dataEntry.iamUserDivisionMaps?.map(division => division.divisionId);
            const divisionCodes = this.divisions()
                .filter(division => usersDivisionsIds?.includes(division.id))
                .map(division => division.divisionCode);
            const usersRoleIds = dataEntry.iamUserDivisionMaps?.map(role => role.iamUserRoleDivMaps[0].roleId);
            const roleNames = this.roles()
                .filter(role => usersRoleIds?.includes(role.id))
                .map(role => role.name)[0];
            return {
                id: dataEntry.id,
                user: `${dataEntry.firstName} ${dataEntry.lastName}`,
                divisions: divisionCodes ?? [],
                role: roleNames,
                actions: [{value: 'edit', display: 'Edit'}],
            };
        })?.sort(function (a, b) {
            return a.user!.localeCompare(b.user!);
        })
    });

    ngOnChanges() {
        this.dataSource = new MatTableDataSource<IamUserTableData>(this.iamUserTableData());
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
}
